<template>
  <div class="home-page-wrapper about-page-wrapper">
    <HeroBanner
      :title="contactUs.title"
      image-url-present
      :image-url="generateImageUrl(contactUs.image)"
    />
    <Social />
    <ContactSection
      :description="contactUs.subTitle"
      :info-data="contactUs.additionalInfo"
      :title="contactUs.title"
      :mail-to="contactUs.mailTo"
    />
    <ContactDetail
      :title="contactUs.title"
      :contact-data="contactData"
      :description="contactUs.contactUsInfo"
    />
  </div>
</template>

<script>
import HeroBanner from "@/pageComponents/globalUi/hero-banner";
import ContactSection from "@/pageComponents/contact/contact-section/index";
import ContactDetail from "@/pageComponents/contact/contact-detail";
import Social from '@/pageComponents/social/Social'
import { mapGetters } from "vuex";

const MISC_STORE_KEY = "miscStore";

export default {
  name: "Contact",
  components: {
    HeroBanner,
    ContactSection,
    ContactDetail,
    Social
  },
  computed: {
    ...mapGetters({
      contactUs: `${MISC_STORE_KEY}/contactUs`,
      contactUsLoading: `${MISC_STORE_KEY}/contactUsLoading`,
      contactData: `${MISC_STORE_KEY}/formattedContactDetails`
    })
  },
  async mounted() {
    await this.$store.dispatch(`${MISC_STORE_KEY}/getContactUs`);
  },
  data() {
    return {
      contactInfoData: []
    };
  }
};
</script>

<style></style>
